import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import Loading from '../../components/loading';

// import LoginForm from "./loginForm";
import * as loginActions from '../../redux/auth/actions';
import RseeLogo from '../../assets/images/logo/rsee.png';

import './login.scss';

export class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { password: '', userName: '' };
  }

  handleForm = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  submitForm = (userName, password) => {
    this.props
      .login(userName, password)
      .then(response => {
        this.props.history.push('/dashboard');
      })
      .catch(err => {
        console.log('in catch response', err);
      });
  };

  render() {
    let { userName, password } = this.state;
    const { error, failed, loading, message } = this.props;
    return (
      <div className="col m-0 p-0 main-content main-image w-100 ">
        <div className="d-flex flex-column align-items-center justify-content-center h-100">
          <img src={RseeLogo} className="login__rsee-logo" />
          <form
            onSubmit={event => {
              event.preventDefault();
              this.submitForm(userName, password);
            }}
            className="col-lg-4 col-md-6 col-sm-8 p-5 card login-bg"
          >
            {error && <div className="alert alert-danger">{locales('messages.server.error')}</div>}
            {failed && <div className="alert alert-danger">{message}</div>}

            <Loading spinning={loading}>
              <h3 className="text-white d-flex justify-content-start font-italic">
                {locales('titles.enter')}
              </h3>
              <input
                value={userName}
                type="text"
                onChange={event => this.handleForm(event)}
                name="userName"
                className="form-control my-1 p-1"
                placeholder={locales('messages.username')}
              />
              <i className="login-username-icon fal fa-user px-1" />
              <input
                value={password}
                name="password"
                onChange={event => this.handleForm(event)}
                className="form-control my-2 p-1"
                type="password"
                placeholder={locales('messages.password')}
              />
              <i type="lock" className="login-password-icon far fa-lock-alt px-1" />
              <div className="p-0 d-flex justify-content-center pointer align-items-end my-2">
                <Link to="/forgetPassword" className="text-white">
                  {locales('titles.forgetMyPassword')}
                </Link>
              </div>
              <div className="p-0 d-flex justify-content-end align-items-end">
                <button type="submit" className="w-100 btn btn-primary mt-4">
                  {locales('titles.enter')}
                </button>
              </div>
            </Loading>
          </form>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    loggedInUser: state.authReducer.loggedInUser,
    error: state.authReducer.error,
    failed: state.authReducer.failed,
    loading: state.authReducer.loading,
    message: state.authReducer.message
  };
}

function mapDispatchToProps(dispatch) {
  return {
    login: (userName, password) => dispatch(loginActions.login(userName, password))
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LoginPage)
);
